<template lang="html">
  <div class="widget-layer" :id="_uid + '-widget-layer'">
    <object class="widget-iframe" :id="_uid + '-widget-iframe'" :data="widgetHtml"></object>
  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

export default {
  props: ['widget'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    var div = document.getElementById(this._uid + '-widget-layer')
    var box1 = this.getBox(this.widget)
    var box2 = this.getBox(this.widget.page)

    var x = box1.x / box2.width
    var y = box1.y / box2.height
    var width = box1.width / box2.width
    var height = box1.height / box2.height

    if (width > 1) {
      width = 1
    }

    div.style.left = x * 100 + '%'
    div.style.top = y * 100 + '%'
    div.style.width = width * 100 + '%'
    div.style.height = height * 100 + '%'

    if (this.widget.kind === 'Video') {
      var oldIFrame = document.getElementById(this._uid + '-widget-iframe')
      div.removeChild(oldIFrame)

      var template = document.createElement('div')
      var html = this.widget.attributes.OEmbedHtml.trim()
      template.innerHTML = html
      var iFrame = template.firstChild
      iFrame.style.width = '100%'
      iFrame.style.height = '100%'
      div.appendChild(iFrame)
    }
  },
  computed: {
    widgetHtml: function () {
      if (this.widget.kind === 'Video') {
        return ''
      }
      return this.opsUrl + 'Widgets/' + encodeURIComponent(this.widget.id) + '/' + encodeURIComponent(this.widget.id) + '.html'
    },
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      isScrolling: 'getIsScrolling'
    })
  },
  watch: {

  },
  methods: {
    getBox (obj) {
      return {
        x: parseFloat(obj.attributes.ObjectXPos),
        y: parseFloat(obj.attributes.ObjectYPos),
        width: parseFloat(obj.attributes.ObjectWidth),
        height: parseFloat(obj.attributes.ObjectHeight)
      }
    }
  }
}
</script>

<style lang=scss>
.widget-layer {
  width: 100%;
  position: absolute;
  z-index: 100;
  /* background-color: white; */
  /* opacity: 0; */
  /* cursor: pointer; */
  .widget-iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
